import { Reducer } from 'redux'
import {
  TabValues,
  ActionTypes,
  CARDS_ACTIONS,
  TRANSACTION_TAB_KEY,
  Filters,
  SORT_TYPE,
  IssuingPlan,
} from './types'

const initialState: State = {
  transactionsTabKey: TRANSACTION_TAB_KEY.TRANSACTIONS,
  currentIssuingPlanOpaqueId: undefined,
  issuingPlans: [],
  tabValues: {
    [TRANSACTION_TAB_KEY.TRANSACTIONS]: {
      isTxnLoading: false,
      transactions: [],
      totalCount: 0,
      page: {
        number: 1,
        size: 10,
      },
      filters: {
        sort: SORT_TYPE.CREATED_AT_DESC,
      },
    },
    [TRANSACTION_TAB_KEY.CARDS]: {
      isTxnLoading: false,
      cards: [],
      totalCount: 0,
      page: {
        number: 1,
        size: 10,
      },
      filters: {
        sort: SORT_TYPE.CREATED_AT_DESC,
      },
    },
    [TRANSACTION_TAB_KEY.FRAUD]: {
      isTxnLoading: false,
      transactions: [],
      totalCount: 0,
      page: {
        number: 1,
        size: 10,
      },
      filters: {
        sort: SORT_TYPE.CREATED_AT_DESC,
      },
    },
    [TRANSACTION_TAB_KEY.UNSETTLED]: {
      isTxnLoading: false,
      transactions: [],
      totalCount: 0,
      page: {
        number: 1,
        size: 10,
      },
      filters: {
        sort: SORT_TYPE.CREATED_AT_DESC,
      },
    },
    [TRANSACTION_TAB_KEY.CUSTOMERS]: {
      isTxnLoading: false,
      customers: [],
      totalCount: 0,
      page: {
        number: 1,
        size: 10,
      },
      filters: {
        sort: SORT_TYPE.CREATED_AT_DESC,
      },
    },
  },
}

type State = {
  transactionsTabKey: TRANSACTION_TAB_KEY
  currentIssuingPlanOpaqueId: string | undefined
  issuingPlans: IssuingPlan[]
  tabValues: TabValues
}

export const cards: Reducer<State, ActionTypes> = (state = initialState, action) => {
  switch (action.type) {
    case CARDS_ACTIONS.SET_FILTERS: {
      const { transactionsTabKey } = state

      if (transactionsTabKey === null) throw new Error('transactionsTabKey cannot be null!')

      const { filters } = action

      const newTabFilters: Filters = {
        ...state.tabValues[transactionsTabKey].filters,
      }

      Object.keys(filters).forEach((key: string) => {
        const values = filters[key]
        newTabFilters[key] = values
      })

      return {
        ...state,
        tabValues: {
          ...state.tabValues,
          [transactionsTabKey]: {
            ...state.tabValues[transactionsTabKey],
            filters: {
              ...state.tabValues[transactionsTabKey].filters,
              ...newTabFilters,
            },
          },
        },
      } as State
    }

    case CARDS_ACTIONS.SET_PAGE: {
      const { transactionsTabKey } = state

      if (transactionsTabKey === null) throw new Error('transactionsTabKey cannot be null!')

      return {
        ...state,
        tabValues: {
          ...state.tabValues,
          [transactionsTabKey]: {
            ...state.tabValues[transactionsTabKey],
            page: action.page,
          },
        },
      }
    }

    case CARDS_ACTIONS.SET_TOTAL_COUNT: {
      const { transactionsTabKey } = state

      if (transactionsTabKey === null) throw new Error('transactionsTabKey cannot be null!')

      return {
        ...state,
        tabValues: {
          ...state.tabValues,
          [transactionsTabKey]: {
            ...state.tabValues[transactionsTabKey],
            totalCount: action.totalCount,
          },
        },
      }
    }

    case CARDS_ACTIONS.SWITCH_TRANSACTION_TAB: {
      return {
        ...state,
        transactionsTabKey: action.transactionsTabKey,
      }
    }

    case CARDS_ACTIONS.SET_IS_TXN_LOADING: {
      const { transactionsTabKey } = state

      if (transactionsTabKey === null) throw new Error('transactionsTabKey cannot be null!')

      return {
        ...state,
        tabValues: {
          ...state.tabValues,
          [transactionsTabKey]: {
            ...state.tabValues[transactionsTabKey],
            isTxnLoading: action.isTxnLoading,
          },
        },
      }
    }

    case CARDS_ACTIONS.SET_TRANSACTIONS: {
      return {
        ...state,
        tabValues: {
          ...state.tabValues,
          [TRANSACTION_TAB_KEY.TRANSACTIONS]: {
            ...state.tabValues[TRANSACTION_TAB_KEY.TRANSACTIONS],
            transactions: action.transactions,
          },
        },
      }
    }

    case CARDS_ACTIONS.SET_FRAUD_EVENTS: {
      return {
        ...state,
        tabValues: {
          ...state.tabValues,
          [TRANSACTION_TAB_KEY.FRAUD]: {
            ...state.tabValues[TRANSACTION_TAB_KEY.FRAUD],
            transactions: action.transactions,
          },
        },
      }
    }

    case CARDS_ACTIONS.SET_UNSETTLED_TRANSACTIONS: {
      return {
        ...state,
        tabValues: {
          ...state.tabValues,
          [TRANSACTION_TAB_KEY.UNSETTLED]: {
            ...state.tabValues[TRANSACTION_TAB_KEY.UNSETTLED],
            transactions: action.transactions,
          },
        },
      }
    }

    case CARDS_ACTIONS.SET_CUSTOMERS: {
      return {
        ...state,
        tabValues: {
          ...state.tabValues,
          [TRANSACTION_TAB_KEY.CUSTOMERS]: {
            ...state.tabValues[TRANSACTION_TAB_KEY.CUSTOMERS],
            customers: action.customers,
          },
        },
      }
    }

    case CARDS_ACTIONS.SET_CARDS: {
      return {
        ...state,
        tabValues: {
          ...state.tabValues,
          [TRANSACTION_TAB_KEY.CARDS]: {
            ...state.tabValues[TRANSACTION_TAB_KEY.CARDS],
            cards: action.cards,
          },
        },
      }
    }

    case CARDS_ACTIONS.SET_CURRENT_ISSUING_PLAN_OPAQUE_ID: {
      return {
        ...state,
        currentIssuingPlanOpaqueId: action.currentIssuingPlanOpaqueId,
      }
    }

    case CARDS_ACTIONS.SET_ISSUING_PLANS: {
      return {
        ...state,
        issuingPlans: action.issuingPlans,
      }
    }

    default:
      return state
  }
}
